import * as React from 'react';
import { MainNavigationItems, SubCategories, NavigationItem, CategoryLinkItem } from '@packages/common';
import styled from 'styled-components';

import { MobileNavigationCategoryLevel, MobileNavigationMainCategoryLevel } from './MobileNavigationCategoryLevel';

const CategoryLevelWrapper = styled.div`
  overflow-x: hidden;
`;

const CategoryLevels = styled.div<{ level: number }>`
  display: flex;
  width: 400%;
  margin-left: ${({ level }) => level * 100 * -1}%;
  transition: margin 240ms ease-in-out;
`;

export interface MobileNavigationCategoriesTabProps {
  mainCategories: MainNavigationItems['main'];
  fetchSubCategories: (url: string) => Promise<SubCategories>;
}

const initialSubCategories: { [key: number]: SubCategories } = {
  1: { items: [], parents: [] },
  2: { items: [], parents: [] },
  3: { items: [], parents: [] },
};

export const MobileNavigationCategoriesTab: React.FC<MobileNavigationCategoriesTabProps> = ({
  mainCategories,
  fetchSubCategories,
}) => {
  const [level, setLevel] = React.useState(0);
  const [subCategories, setSubCategories] = React.useState(initialSubCategories);
  const [loadingItemUrl, setLoadingItemUrl] = React.useState<string | null>(null);

  const handleGoBack = (level: number) => () => setLevel(level);

  const handleItemClick = async (item: NavigationItem | CategoryLinkItem) => {
    setLoadingItemUrl(item.url);
    const itemCommon = { hasChildren: true, ...item };
    if (itemCommon.hasChildren) {
      const nextLevel = level + 1;

      const data = await fetchSubCategories(item.url);
      setSubCategories((state) => {
        return {
          ...state,
          [nextLevel]: data,
        };
      });
      setLevel(nextLevel);
      setLoadingItemUrl(null);
    }
  };

  return (
    <CategoryLevelWrapper>
      <CategoryLevels level={level}>
        <MobileNavigationMainCategoryLevel
          loadingItemUrl={loadingItemUrl}
          main={mainCategories}
          handleItemClick={handleItemClick}
        />
        {Object.keys(subCategories).map((_, index) => (
          <MobileNavigationCategoryLevel
            loadingItemUrl={loadingItemUrl}
            key={`category-level-${index}`}
            handleGoBack={handleGoBack(index)}
            subCategories={subCategories[index + 1]}
            handleItemClick={handleItemClick}
          ></MobileNavigationCategoryLevel>
        ))}
      </CategoryLevels>
    </CategoryLevelWrapper>
  );
};
